import { createSlice } from '@reduxjs/toolkit';

import { getOpsConfirmedOrders } from '../../apis';

export const OpsConfirmedOrders = createSlice({
    name: 'opsConfirmedOrders',
    initialState: {
        opsConfirmOrderIsLoading: false,
        data : [],
        error: ''
    },

    reducers: {
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getOpsConfirmedOrders.pending, (state, action) => {
            state.opsConfirmOrderIsLoading = true;
        })
        builder.addCase(getOpsConfirmedOrders.fulfilled, (state, action) => {
            state.opsConfirmOrderIsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getOpsConfirmedOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.opsConfirmOrderIsLoading = false;
        })
    }
})

export const { clearErrorState } = OpsConfirmedOrders.actions
export default OpsConfirmedOrders.reducer